// Core ribbon animation settings
export const RIBBON_CONFIG = {
  RIBBON_WIDTH: 60,
  ANIMATION_FRAMES: 160,
  MAX_PROGRESS: 1.8, // > 1 allows exit animation
  RIBBON_VISIBLE_LENGTH: 0.6, // Trail length (0-1)
  OVERLAP_BUFFER: 10,
  ANGLE_CALCULATION_DELTA: 0.5,
} as const;

// SVG path data from design
export const PATH_DATA =
  'M-250 517c65-177 362-320 599-105 238 215 413 162 621-57 209-219 358-139 642-67 228 57 348-163 688-388';

// Transform settings for ribbon positioning
export const TRANSFORM_CONFIG = {
  TRANSLATE_X: 131,
  TRANSLATE_Y: 629,
  SCALE_X: 0.9,
  SCALE_Y: 0.84,
} as const;
